import React from 'react';
import {
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
  Tooltip,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { formatSubRoleLabel } from '../../utils/roleDisplayUtils';

const AccessPermissionsSection = ({
  videoFeedBackNotesPrivate,
  setVideoFeedBackNotesPrivate,
  peopleToShareWith,
  editAndViewIds,
  setEditAndViewIds,
  viewOnlyIds,
  setViewOnlyIds,
}) => (
  <>
    <FormControlLabel
      control={
        <Checkbox
          checked={videoFeedBackNotesPrivate}
          onChange={(e) => {
            setVideoFeedBackNotesPrivate(e.target.checked);
          }}
          color='primary'
        />
      }
      label='Are video feedback notes private?'
    />
    {peopleToShareWith?.length > 0 && (
      <Box sx={{ mt: 2 }}>
        {/* Edit & View Access */}
        <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mt: 1 }}>
          Edit & View Access:
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', mb: 2 }}>
          {peopleToShareWith.map((person) => {
            const uid = person.uid;
            const isChecked = editAndViewIds.includes(uid);
            const isInViewOnly = viewOnlyIds.includes(uid);
            const subRoleLabel = formatSubRoleLabel(person?.info?.subRoleName);
            const showTooltip = Boolean(subRoleLabel);

            return (
              <FormControlLabel
                key={`edit-${uid}`}
                control={
                  <Checkbox
                    checked={isChecked}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setEditAndViewIds((prev) => [...prev, uid]);
                        setViewOnlyIds((prev) =>
                          prev.filter((id) => id !== uid)
                        );
                      } else {
                        setEditAndViewIds((prev) =>
                          prev.filter((id) => id !== uid)
                        );
                      }
                    }}
                    disabled={isInViewOnly}
                  />
                }
                label={
                  <span>
                    {person.info.fullname}
                    {showTooltip && (
                      <Tooltip title={subRoleLabel} arrow placement='top'>
                        <InfoIcon
                          sx={{
                            fontSize: 'small',
                            ml: 0.5,
                            verticalAlign: 'middle',
                            color: 'action.active',
                            cursor: 'help',
                          }}
                        />
                      </Tooltip>
                    )}
                    {isInViewOnly && (
                      <Tooltip
                        title='Already in View Only'
                        arrow
                        placement='top'
                      >
                        <span
                          style={{
                            fontSize: 'small',
                            marginLeft: '4px',
                            color: 'gray',
                            fontStyle: 'italic',
                          }}
                        >
                          (in View Only)
                        </span>
                      </Tooltip>
                    )}
                  </span>
                }
                sx={{ mr: 2 }}
              />
            );
          })}
        </Box>

        {/* View Only Access */}
        <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mt: 1 }}>
          View Only Access:
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', mb: 2 }}>
          {peopleToShareWith.map((person) => {
            const uid = person.uid;
            const isChecked = viewOnlyIds.includes(uid);
            const isInEditAccess = editAndViewIds.includes(uid);
            const subRoleLabel = formatSubRoleLabel(person?.info?.subRoleName);
            const showTooltip = Boolean(subRoleLabel);

            return (
              <FormControlLabel
                key={`view-${uid}`}
                control={
                  <Checkbox
                    checked={isChecked}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setViewOnlyIds((prev) => [...prev, uid]);
                        setEditAndViewIds((prev) =>
                          prev.filter((id) => id !== uid)
                        );
                      } else {
                        setViewOnlyIds((prev) =>
                          prev.filter((id) => id !== uid)
                        );
                      }
                    }}
                    disabled={isInEditAccess}
                  />
                }
                label={
                  <span>
                    {person.info.fullname}
                    {showTooltip && (
                      <Tooltip title={subRoleLabel} arrow placement='top'>
                        <InfoIcon
                          sx={{
                            fontSize: 'small',
                            ml: 0.5,
                            verticalAlign: 'middle',
                            color: 'action.active',
                            cursor: 'help',
                          }}
                        />
                      </Tooltip>
                    )}
                    {isInEditAccess && (
                      <Tooltip
                        title='Already in Edit & View'
                        arrow
                        placement='top'
                      >
                        <span
                          style={{
                            fontSize: 'small',
                            marginLeft: '4px',
                            color: 'gray',
                            fontStyle: 'italic',
                          }}
                        >
                          (in Edit & View)
                        </span>
                      </Tooltip>
                    )}
                  </span>
                }
                sx={{ mr: 2 }}
              />
            );
          })}
        </Box>
      </Box>
    )}
  </>
);

export default AccessPermissionsSection;
